import React, { useEffect, useState } from "react";
import {
  MaterialReactTable,
} from "material-react-table";
import { BadgeCheck } from "lucide-react";
import axios from "axios";
import { base_url } from "../../config";
import EurAIProofModal from "./EurAIProofModal";

const EurAI = () => {
  const [data, setData] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [pdf, setPDF] = useState(null);
  const [rowData, setRowData] = useState(null);

  const reloadData = async () => {
    try {
      const res = await axios.get(`${base_url}/api/admin/eurai_pending`);
      setData(res.data);
    } catch (err) {
      console.error("Error fetching pending EurAI claims:", err);
    }
  };

  useEffect(() => {
    reloadData();
  }, []);

  const columns = [
    { accessorKey: "code", header: "Code" },
    { accessorKey: "name", header: "Name" },
    { accessorKey: "email", header: "Email" },
    { accessorKey: "type", header: "Type" },
    {
      id: "actions",
      header: "Validate",
      Cell: ({ row }) => (
        <button
          type="button"
          onClick={() => openProof(row.original)}
          style={{
            padding: "6px 12px",
            border: "1px solid #ccc",
            borderRadius: "4px",
            background: "#f5f5f5",
            cursor: "pointer",
          }}
        >
          Open
        </button>
      ),
    },
  ];

  const openProof = async (row) => {
    try {
      const res = await axios.get(`${base_url}/api/admin/students_pdf`, {
        params: { id: row.eurai_proof_file_id },
        responseType: "blob",
      });
      const blob = new Blob([res.data], { type: "application/pdf" });
      setPDF(blob);
      setRowData(row);
      setModalOpen(true);
    } catch (err) {
      console.error("Error fetching EurAI proof:", err);
    }
  };

  return (
    <>
      <div className="text-2xl mt-4 pb-4 font-bold flex gap-8 items-center">
        <BadgeCheck />
        EurAI Validations
      </div>
      <div style={{ flex: "1 1 0", paddingBottom: "20px" }}>
        <MaterialReactTable columns={columns} data={data} />
      </div>
      <EurAIProofModal
        isOpen={modalOpen}
        onClose={() => setModalOpen(false)}
        pdf={pdf}
        row={rowData}
        onAccept={reloadData}
        onDecline={reloadData}
      />
    </>
  );
};

export default EurAI;
